import React from 'react';
import { NavLink } from 'react-router-dom';
import { LEGAL_DOCS } from '../../data/legal';

const linkClass = ({ isActive }) =>
  `block px-4 py-3 rounded-lg text-sm font-medium border transition-colors ${
    isActive
      ? 'bg-orange-500/15 border-orange-500/40 text-orange-300'
      : 'border-white/10 text-gray-400 hover:text-white hover:bg-white/5'
  }`;

export const LegalNav = ({ language }) => (
  <nav className="flex lg:flex-col gap-2 overflow-x-auto lg:sticky lg:top-36" data-testid="legal-nav">
    {LEGAL_DOCS.map((doc) => (
      <NavLink key={doc.key} to={doc.path} className={linkClass} data-testid={`legal-nav-${doc.key}`}>
        <span className="whitespace-nowrap">{doc.label[language]}</span>
      </NavLink>
    ))}
  </nav>
);
